module.exports = __webpack_public_path__ + "img/trima-welcome.9ec92baf.png";